import { Component, Output, Input, OnInit, EventEmitter, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
 ActivationWay,
 SendActivationCodeRequest,
 SendActivationCodeResponse,
} from '@core/models/DTOs/authentication.dto';
import { AuthService } from '@core/services/authentication/auth.service';
import { WebengageService } from '@core/services/webengage.service';
import { catchError } from 'rxjs';

@Component({
 selector: 'iho-forget-pass',
 templateUrl: './forget-pass.component.html',
 styleUrls: ['./forget-pass.component.scss'],
})
export class ForgetPassComponent implements OnInit {
 @Input() typeSection: string = 'forget';
 @Output() status = new EventEmitter();
 @Output() emitEmailMobile = new EventEmitter();
 @Output() emitActivationCode = new EventEmitter();
 errName: string = '';
 showLoading: boolean = false;

 isEmail: boolean = false;
 constructor(
  public AuthService: AuthService,
  private webengageService: WebengageService
) {}
 emailMobile: string = '';

 errValidEmailPhone: boolean = false;

 isSend: boolean = true;

 ngOnInit(): void {}

 destroyRef = inject(DestroyRef);

 validatePhoneEmail() {
  let pattern =
   /(^(0|\u06F0)(9|\u06F9)(\d|[\u06F0-\u06F9]){9}$)|(^[\w\-]+(?:\.[\w\-]+)*@(?:[\w\-]+\.)+[a-zA-Z]{2,7}$)/;
  let EMAIL_REGEX =
   /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (pattern.test(this.emailMobile)) {
   if (EMAIL_REGEX.test(this.emailMobile)) {
    this.isEmail = true;
   }

   this.errValidEmailPhone = false;
   this.isSend = true;
  } else {
   this.isSend = false;
   this.errValidEmailPhone = true;
   return;
  }

  if (this.isSend) {
   // otp
   let modelSendActivationCode: SendActivationCodeRequest = {
    Email: this.isEmail ? this.emailMobile : '',
    Mobile: !this.isEmail ? this.emailMobile : '',
    ActivationWay: ActivationWay.ForgetPassword,
    Token: '',
   };
   this.showLoading = true;
   this.AuthService.SendActivationCode(modelSendActivationCode)

    // active code error
    .pipe(
     takeUntilDestroyed(this.destroyRef),
     catchError((err) => {
      this.showLoading = false;

      this.errName = err.error.Message;
      throw 'error in source. Details: ' + err;
     })
    )
    .subscribe((res: SendActivationCodeResponse) => {
     this.webengageService.trackIntrack('forget', {
      emailOrPhone: this.emailMobile
     })
     this.showLoading = false;
     this.emitActivationCode.emit(res);
     this.emitEmailMobile.emit(this.emailMobile);
     this.status.emit('step-otp');
    });
  }
 }
}
